var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-e0c9746e": "",
    id: "CartIcon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 668.8 668.9",
    xmlSpace: "preserve",
    className: "",
    width: 668.8,
    height: 668.9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-v-e0c9746e": "",
    className: "sub_one"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-v-e0c9746e": "",
    className: "st0",
    d: "M209.7,165.8c0-72.9,59.1-131.9,131.9-131.9S473.5,93,473.5,165.8",
    stroke: "#909090",
    fill: "none",
    strokeWidth: "50px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-v-e0c9746e": "",
    className: "st0",
    d: "M479.4,170h9.1H500h7.5h3.5c16.9,0,34.9,5.5,50.2,18.3c15,12.6,28.7,33.4,35.2,66.4l27.7,206.2     c0,0.2,0.1,0.3,0.1,0.5c11.2,72.1-3.9,109.8-27,130.7c-24.6,22.2-65.1,31.7-118.2,31.7H181.2c-51.2,0-91.6-13-116.8-37.6     c-24.3-23.7-38.9-62.6-29.6-124.9c0.1-0.2,0.1-0.3,0.1-0.4l27.6-205.7c15-63.8,53.8-85.2,85.5-85.2h48h13.7H477",
    stroke: "#909090",
    fill: "none",
    strokeWidth: "50px"
  })), /*#__PURE__*/React.createElement("path", {
    "data-v-e0c9746e": "",
    className: "st1",
    d: "M209.7,165.8c0-72.9,59.1-131.9,131.9-131.9S473.5,93,473.5,165.8",
    style: {},
    stroke: "#000000",
    fill: "none",
    strokeWidth: "63px"
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-e0c9746e": "",
    className: "st1",
    d: "M479.4,170h9.1H500h7.5h3.5c16.9,0,34.9,5.5,50.2,18.3c15,12.6,28.7,33.4,35.2,66.4l27.7,206.2     c0,0.2,0.1,0.3,0.1,0.5c11.2,72.1-3.9,109.8-27,130.7c-24.6,22.2-65.1,31.7-118.2,31.7H181.2c-51.2,0-91.6-13-116.8-37.6     c-24.3-23.7-38.9-62.6-29.6-124.9c0.1-0.2,0.1-0.3,0.1-0.4l27.6-205.7c15-63.8,53.8-85.2,85.5-85.2h48h13.7H477",
    style: {},
    stroke: "#000000",
    fill: "none",
    strokeWidth: "63px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIcon);
export default __webpack_public_path__ + "static/media/c-icon.907ddee4a530381cc126fbbe11e65ed9.svg";
export { ForwardRef as ReactComponent };